import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  quarterlyFeedback,
  RoutesEnum,
  BreadcrumbLabels,
  VendorProfile,
} from '@constants/global.enum';
import { OpsVendors } from '@interfaces/vendor-management-model';
import { GlobalErrorService } from '@services/global-error.service';

@Component({
  selector: 'app-vendor-profile-page',
  templateUrl: './vendor-profile-page.component.html',
  styleUrls: ['./vendor-profile-page.component.scss'],
})
export class VendorProfileComponent implements OnInit {
  VendorProfile = VendorProfile;
  vendorId: string | null = null;
  vendorName: string | null = null;
  quarterlyFeedback = quarterlyFeedback;
  BreadcrumbLabels = BreadcrumbLabels;
  RoutesEnum = RoutesEnum;

  @Input() vendorData: OpsVendors | null = null;
  @Output() close = new EventEmitter<void>();

  constructor(private router: Router, private route: ActivatedRoute,
    private errorHandler: GlobalErrorService,) {}

  ngOnInit(): void {
    if (this.vendorData) {
      this.vendorId = this.vendorData.vendorId?.toString() || null;
      this.vendorName = this.vendorData.vendorName || null;
    } else {
      this.route.params.subscribe(params => {
      this.vendorId = params['vendorId'];
      this.vendorName = params['vendorName'] ? decodeURIComponent(params['vendorName']) : null;
    });
    }
  }

  onQuarterlyFeedbackClick() {
    this.router.navigate(
      [`${this.quarterlyFeedback.feedbackform}${this.vendorId}`],
      { queryParams: { vendorName: this.vendorName },
        state: { vendorData: this.vendorData }
      },
    );
  }

  navigateToVendorDashboard(): void {
     if (this.router.url.includes('vendors-profile')) {
      this.router.navigate([`/${RoutesEnum.asset}`]);
    }else{
    this.router.navigate([`/${RoutesEnum.OpsVendorManagement}`]);
    }
  }

  navigateToVendorsList(): void {
    if (this.vendorData) {
     this.close.emit();
    } else if (this.router.url.includes('vendors-profile')) {
      this.router.navigate([`/${RoutesEnum.asset}/${RoutesEnum.stats}`]);
    } else {
      this.router.navigate([`/${RoutesEnum.OpsVendorManagement}/${RoutesEnum.vendorsList}`]);
    }
  }

  getBreadcrumbLabel(): string {
    return this.router.url.includes('vendors-profile') ? BreadcrumbLabels.AssetManagement : BreadcrumbLabels.VendorManagement;
  }

  getSeparatorBreadcrumbLabel(): string {
    return this.router.url.includes('vendors-profile') ? BreadcrumbLabels.VendorStats : BreadcrumbLabels.VendorsList;
  }

}
